import React from 'react'

// Ported from the source project's src/components/site/Process.tsx (verbatim - no
// motion/Reveal usage in the source component itself; the page wraps the whole section).
const Process = ({ section, steps }) => {
    return (
        <section className="section" id="process">
            <div className="container">
                <div className="section-eyebrow">{section.eyebrow}</div>
                <h2 className="section-title">{section.title}</h2>
                <div className="process-grid">
                    {steps.map((step) => (
                        <div className="process-step" key={step.order}>
                            <div className="process-num">{step.num}</div>
                            <div className="process-title">{step.title}</div>
                            <p className="process-desc">{step.description}</p>
                            <div className="process-arrow">→</div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Process;
